import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  getHasLoadedOptions, getIndustryTypeOptions, getAccountantHasAccessToOptions,
} from 'store/modules/options/selectors';
import { IReducerState, history } from 'store/main-reducer';
import { getIsCharity, getIsAccountant, getCompanyDetailsData } from 'store/modules/sign-up/selectors';
import { CallbackRequestModal } from 'views/components/CallbackRequestModal/CallbackRequestModal';
import { actionSetCompanyDetails } from 'store/modules/sign-up/actions';
import { ICompanyDetails, AccountantTuple } from 'types';
import { actionAccountantLookup } from 'store/modules/accountant-lookup/actions';
import { getAccountantLookupResults, getAccountantLookupIsLoading, getAccountantLookupError } from 'store/modules/accountant-lookup/selectors';
import { CompanyDetailsView } from './CompanyDetails';

interface ActionProps {
  setCompanyDetails: typeof actionSetCompanyDetails;
  accountantLookup: typeof actionAccountantLookup;
}

interface ValueProps {
  defaultValues?: ICompanyDetails;
  hasLoadedOptions: boolean;
  isCharity: boolean;
  industryTypeOptions: string[];
  isAccountant: boolean;
  accountantAccessOptions: string[];
  accountantResults: AccountantTuple[];
  accountantIsLoading: boolean;
  accountantError?: string;
}

interface Props extends ActionProps, ValueProps {
  intl: IntlShape;
}

const CompanyDetailsController = (props: Props) => {
  const {
    intl,
    hasLoadedOptions,
    isCharity,
    industryTypeOptions,
    isAccountant,
    setCompanyDetails,
    defaultValues,
    accountantAccessOptions,
    accountantLookup,
    accountantResults,
    accountantIsLoading,
    accountantError,
  } = props;

  const goToNextStep = (data: ICompanyDetails) => {
    setCompanyDetails(data);
    history.push('/sign-up/payroll-information');
  };

  const goToPreviousStep = () => {
    history.push('/sign-up/contact-details');
  };

  if (!hasLoadedOptions) {
    history.push('/');
  }

  return (
    <>
      <CompanyDetailsView
        intl={intl}
        goToNextStep={goToNextStep}
        goToPreviousStep={goToPreviousStep}
        isCharity={isCharity}
        industryTypeOptions={industryTypeOptions}
        isAccountant={isAccountant}
        defaultValues={defaultValues}
        accountantAccessOptions={accountantAccessOptions}
        accountantLookup={accountantLookup}
        accountantResults={accountantResults}
        accountantIsLoading={accountantIsLoading}
        accountantError={accountantError}
      />
      <CallbackRequestModal />
    </>
  );
};

const mapStateToProps = (state: IReducerState): ValueProps => ({
  hasLoadedOptions: getHasLoadedOptions(state),
  isCharity: getIsCharity(state),
  industryTypeOptions: getIndustryTypeOptions(state),
  isAccountant: getIsAccountant(state),
  defaultValues: getCompanyDetailsData(state),
  accountantAccessOptions: getAccountantHasAccessToOptions(state),
  accountantResults: getAccountantLookupResults(state),
  accountantIsLoading: getAccountantLookupIsLoading(state),
  accountantError: getAccountantLookupError(state),
});

const mapDispatchToProps: ActionProps = {
  setCompanyDetails: actionSetCompanyDetails,
  accountantLookup: actionAccountantLookup,
};

export const CompanyDetails = injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompanyDetailsController));
